import React, {FC} from 'react';
import styled from 'styled-components';
import {
  createHelpCenterArticleUrl,
  createHelpCenterSectionUrl,
} from '../../../pages/HelpCenter/routes';
import {HelpCenterLandingPageData} from '../../../pages/HelpCenter/types';
import {useMedia} from '../../../utils/hooks/useMedia';
import getHelpCenterSectionIconName from '../../Icon/getHelpCenterSectionIconName';
import {
  QueryColumnCount,
  TitledGridSection,
} from '../../Sections/TitledGridSection';
import {
  desktopLargeMinWidth,
  mediaMaxTablet,
  mediaMinDesktopLarge,
} from '../../constants/customMedia';
import {SuggestionProps} from '../common/Suggestions';
import HelpSectionTile from './HelpSectionTile';

interface Props {
  title: string;
  highlightQuestions: HelpCenterLandingPageData['highlightQuestions'];
  translations: {more_questions: string};
  suggestionsProps: SuggestionProps;
}

const gridColumnConfig: QueryColumnCount[] = [
  [
    `only screen and (min-width: 0px) and (max-width: ${
      desktopLargeMinWidth - 1
    }px)`,
    2,
  ],
  [mediaMinDesktopLarge, 3],
];

const StyledTitledGridSection = styled(TitledGridSection)<{$isMobile: boolean}>`
  padding-top: ${({$isMobile}) => ($isMobile ? '8px' : '60px')};
`;

const HelpSectionLinks: FC<Props> = ({
  title,
  highlightQuestions,
  translations,
}) => {
  const isMobile = useMedia({[mediaMaxTablet]: true}, false);
  return (
    <StyledTitledGridSection
      $isMobile={isMobile}
      title={title}
      columnCount={gridColumnConfig}
      gridGap={isMobile ? 8 : 20}
      containerDataTestId="HelpCenterFaqSectionsContainer"
    >
      {highlightQuestions.map(({section, highlightQuestions}) => (
        <HelpSectionTile
          key={section.id}
          helpSectionTitle={section.name}
          helpSectionUrl={createHelpCenterSectionUrl(section)}
          faqs={highlightQuestions.map(article => ({
            title: article.name,
            url: createHelpCenterArticleUrl(section, article),
          }))}
          moreQuestionsLabel={translations.more_questions}
          helpSectionIcon={getHelpCenterSectionIconName(section.id)}
        />
      ))}
    </StyledTitledGridSection>
  );
};

export default HelpSectionLinks;
